import React from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CampingIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    d: "M6 15a1 1 0 0 1 .117 1.993L6 17H3c-.509 0-.935.39-.993.884L2 18v12h4a1 1 0 0 1 .993.883L7 31a1 1 0 0 1-.883.993L6 32H1a1 1 0 0 1-.993-.883L0 31V18a3.007 3.007 0 0 1 2.824-2.995L3 15h3zm23 0a3.007 3.007 0 0 1 2.995 2.824L32 18v13a1 1 0 0 1-.883.993L31 32h-5a1 1 0 0 1-.117-1.993L26 30h4V18c0-.509-.39-.935-.884-.993L29 17h-3a1 1 0 0 1-.117-1.993L26 15h3zM20 0a1 1 0 0 1 .993.883L21 1v4a1 1 0 0 1-1.993.117L19 5V2h-6v3a1 1 0 0 1-.883.993L12 6a1 1 0 0 1-.993-.883L11 5V1a1 1 0 0 1 .883-.993L12 0h8z"
  }), React.createElement("path", {
    d: "M22 4H10C7.248 4 5 6.248 5 9v22a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V9c0-2.752-2.248-5-5-5zm0 2l.175.005A3.013 3.013 0 0 1 25 9v21H7V9c0-1.648 1.352-3 3-3h12z"
  }), React.createElement("path", {
    d: "M26 15a1 1 0 0 1 1 1 5.012 5.012 0 0 1-4.784 4.995L22 21H10c-2.752 0-5-2.248-5-5a1 1 0 0 1 2 0 3.013 3.013 0 0 0 2.825 2.995L10 19h12a3.013 3.013 0 0 0 2.995-2.825L25 16a1 1 0 0 1 1-1z"
  }), React.createElement("path", {
    d: "M12 17a1 1 0 0 1 .993.883L13 18v4a1 1 0 0 1-1.993.117L11 22v-4a1 1 0 0 1 1-1zm8 0a1 1 0 0 1 .993.883L21 18v4a1 1 0 0 1-1.993.117L19 22v-4a1 1 0 0 1 1-1z"
  }));
});

export default CampingIcon;
//# sourceMappingURL=camping.svg.js.map
